import {Directive, ElementRef, Input, effect} from '@angular/core';
import {Store} from "@ngrx/store";
import {toSignal} from "@angular/core/rxjs-interop";
import {AuthSelectors} from "../modules/authentication";
import {OrganisationUserSelectors} from "../modules/organisation-user";


@Directive({
  standalone : true,
  selector: '[minimumRole]'
})
export class RoleAccessDirective {

  @Input() minimumRole: number;

  private activeAccount = toSignal(this.store.select(AuthSelectors.selectActiveAccount));
  private userRole = toSignal(this.store.select(OrganisationUserSelectors.selectActiveOrganisationUserRole));

  constructor(
    private el: ElementRef,
    private store: Store
  ) {
    effect(() => {
      const org = this.activeAccount();
      const role = this.userRole();

      // Guard: wait for inputs to be set
      if (this.minimumRole === undefined || org == null || role == null) {
        return;
      }

      if (+role > this.minimumRole) {
        this.el.nativeElement.style.display = 'none';
      } else {
        this.el.nativeElement.style.display = '';
      }
    });
  }
}
